var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 6,
    fill: "#E5F0ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 15.179C12.3826 15.1797 12.2661 15.1571 12.1574 15.1127C12.0486 15.0683 11.9496 15.0028 11.8662 14.9201L8.29477 11.3486C8.1485 11.1778 8.07206 10.9581 8.08074 10.7334C8.08942 10.5087 8.18258 10.2955 8.34159 10.1365C8.5006 9.9775 8.71376 9.88435 8.93847 9.87567C9.16318 9.86699 9.3829 9.94342 9.5537 10.0897L12.5001 13.0272L15.4376 10.0897C15.6084 9.94342 15.8281 9.86699 16.0529 9.87567C16.2776 9.88435 16.4907 9.9775 16.6497 10.1365C16.8088 10.2955 16.9019 10.5087 16.9106 10.7334C16.9193 10.9581 16.8428 11.1778 16.6966 11.3486L13.1251 14.9201C12.9588 15.085 12.7344 15.178 12.5001 15.179Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 15.1782C12.2635 15.1782 12.0364 15.0841 11.8689 14.9166C11.7015 14.7492 11.6074 14.5221 11.6074 14.2853V5.35672C11.6074 5.11992 11.7015 4.89282 11.8689 4.72538C12.0364 4.55794 12.2635 4.46387 12.5003 4.46387C12.7371 4.46387 12.9642 4.55794 13.1316 4.72538C13.2991 4.89282 13.3931 5.11992 13.3931 5.35672V14.2853C13.3931 14.5221 13.2991 14.7492 13.1316 14.9166C12.9642 15.0841 12.7371 15.1782 12.5003 15.1782ZM18.7503 18.7496H6.25028C6.01348 18.7496 5.78638 18.6555 5.61893 18.4881C5.45149 18.3206 5.35742 18.0935 5.35742 17.8567C5.35742 17.6199 5.45149 17.3928 5.61893 17.2254C5.78638 17.0579 6.01348 16.9639 6.25028 16.9639H18.7503C18.9871 16.9639 19.2142 17.0579 19.3816 17.2254C19.5491 17.3928 19.6431 17.6199 19.6431 17.8567C19.6431 18.0935 19.5491 18.3206 19.3816 18.4881C19.2142 18.6555 18.9871 18.7496 18.7503 18.7496Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6f55ea8d2fe7704a00fb4b737f7e69fc.svg";
export { ForwardRef as ReactComponent };